// Filtres archive des biens : un seul dropdown <details> ouvert à la fois.
// Les <details class="pdw-facet--more"> (Type / Prix / Plus d'options) sont
// natifs et restent ouverts indépendamment → superpositions. On ferme les
// autres à l'ouverture, au clic en dehors (desktop) et à Échap.
(function () {
    const bar = document.querySelector('.pdw-estates-filters');
    if (!bar) {
        return;
    }

    const items = Array.from(bar.querySelectorAll('details.pdw-facet--more'));
    if (!items.length) {
        return;
    }

    // Ouvrir un dropdown ferme les autres (toggle se redéclenche en fermeture
    // mais le garde `!d.open` coupe la récursion).
    items.forEach((d) => {
        d.addEventListener('toggle', () => {
            if (!d.open) {
                return;
            }
            items.forEach((other) => {
                if (other !== d) {
                    other.open = false;
                }
            });
        });
    });

    // Clic en dehors → ferme le dropdown ouvert (mode dropdown desktop seulement ;
    // en mobile les panneaux sont des accordéons dans le drawer).
    document.addEventListener('click', (ev) => {
        if (!window.matchMedia('(min-width: 992px)').matches) {
            return;
        }
        items.forEach((d) => {
            if (d.open && !d.contains(ev.target)) {
                d.open = false;
            }
        });
    });

    // Échap ferme tout.
    document.addEventListener('keydown', (ev) => {
        if (ev.key === 'Escape') {
            items.forEach((d) => {
                d.open = false;
            });
        }
    });
})();
